 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780253063526_COVER from '@/components/text/9780253063526_Cover'
 import TEXT9780253063526_HALFTITLE from '@/components/text/9780253063526_Halftitle'
 import TEXT9780253063526_FRONT01 from '@/components/text/9780253063526_Front01'
 import TEXT9780253063526_TITLE from '@/components/text/9780253063526_Title'
 import TEXT9780253063526_COPYRIGHT from '@/components/text/9780253063526_Copyright'
 import TEXT9780253063526_FRONTMATTER02 from '@/components/text/9780253063526_Frontmatter02'
 import TEXT9780253063526_DEDICATION from '@/components/text/9780253063526_Dedication'
 import TEXT9780253063526_CONTENTS from '@/components/text/9780253063526_Contents'
 import TEXT9780253063526_FRONTMATTER03 from '@/components/text/9780253063526_Frontmatter03'
 import TEXT9780253063526_ACKNOWLEDGMENTS from '@/components/text/9780253063526_Acknowledgments'
 import TEXT9780253063526_FRONTMATTER04 from '@/components/text/9780253063526_Frontmatter04'
 import TEXT9780253063526_FRONTMATTER05 from '@/components/text/9780253063526_Frontmatter05'
 import TEXT9780253063526_HALFTITLE01 from '@/components/text/9780253063526_Halftitle01'
 import TEXT9780253063526_PROLOGUE from '@/components/text/9780253063526_Prologue'
 import TEXT9780253063526_FRONTMATTER06 from '@/components/text/9780253063526_Frontmatter06'
 import TEXT9780253063526_CHAPTER01 from '@/components/text/9780253063526_Chapter01'
 import TEXT9780253063526_CHAPTER02 from '@/components/text/9780253063526_Chapter02'
 import TEXT9780253063526_CHAPTER03 from '@/components/text/9780253063526_Chapter03'
 import TEXT9780253063526_CHAPTER04 from '@/components/text/9780253063526_Chapter04'
 import TEXT9780253063526_CHAPTER05 from '@/components/text/9780253063526_Chapter05'
 import TEXT9780253063526_CHAPTER06 from '@/components/text/9780253063526_Chapter06'
 import TEXT9780253063526_CHAPTER07 from '@/components/text/9780253063526_Chapter07'
 import TEXT9780253063526_CHAPTER08 from '@/components/text/9780253063526_Chapter08'
 import TEXT9780253063526_CHAPTER09 from '@/components/text/9780253063526_Chapter09'
 import TEXT9780253063526_CHAPTER10 from '@/components/text/9780253063526_Chapter10'
 import TEXT9780253063526_CHAPTER11 from '@/components/text/9780253063526_Chapter11'
 import TEXT9780253063526_CHAPTER12 from '@/components/text/9780253063526_Chapter12'
 import TEXT9780253063526_CHAPTER13 from '@/components/text/9780253063526_Chapter13'
 import TEXT9780253063526_CHAPTER14 from '@/components/text/9780253063526_Chapter14'
 import TEXT9780253063526_CHAPTER15 from '@/components/text/9780253063526_Chapter15'
 import TEXT9780253063526_BIBLIOGRAPHY from '@/components/text/9780253063526_Bibliography'
 import TEXT9780253063526_MAPS from '@/components/text/9780253063526_Maps'
 import TEXT9780253063526_BACK01 from '@/components/text/9780253063526_Back01'
 import TEXT9780253063526_INDEX from '@/components/text/9780253063526_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780253063526_Contents",
 			"name" : "text/9780253063526_Contents",
 			"component" : TEXT9780253063526_CONTENTS
 		},
 		{
 			"path" : "/text/9780253063526_Frontmatter03",
 			"name" : "text/9780253063526_Frontmatter03",
 			"component" : TEXT9780253063526_FRONTMATTER03
 		},
 		{
 			"path" : "/text/9780253063526_Acknowledgments",
 			"name" : "text/9780253063526_Acknowledgments",
 			"component" : TEXT9780253063526_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/text/9780253063526_Frontmatter04",
 			"name" : "text/9780253063526_Frontmatter04",
 			"component" : TEXT9780253063526_FRONTMATTER04
 		},
 		{
 			"path" : "/text/9780253063526_Frontmatter05",
 			"name" : "text/9780253063526_Frontmatter05",
 			"component" : TEXT9780253063526_FRONTMATTER05
 		},
 		{
 			"path" : "/text/9780253063526_Halftitle01",
 			"name" : "text/9780253063526_Halftitle01",
 			"component" : TEXT9780253063526_HALFTITLE01
 		},
 		{
 			"path" : "/text/9780253063526_Prologue",
 			"name" : "text/9780253063526_Prologue",
 			"component" : TEXT9780253063526_PROLOGUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js